import { render } from "./KickRewards.vue?vue&type=template&id=34cc75ea&scoped=true"
import script from "./KickRewards.vue?vue&type=script&lang=js"
export * from "./KickRewards.vue?vue&type=script&lang=js"

import "./KickRewards.vue?vue&type=style&index=0&id=34cc75ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34cc75ea"]])

export default __exports__